(() => {
  const HEADER_OFFSET = 80; // 必要に応じて調整

  function stopSmoothScroll() {
    document.documentElement.classList.add("is-no-smooth");

    if (window.lenis && typeof window.lenis.stop === "function")
      window.lenis.stop();
    if (window.locoScroll && typeof window.locoScroll.stop === "function")
      window.locoScroll.stop();
  }

  function startSmoothScroll() {
    document.documentElement.classList.remove("is-no-smooth");

    if (window.lenis && typeof window.lenis.start === "function")
      window.lenis.start();
    if (window.locoScroll && typeof window.locoScroll.start === "function")
      window.locoScroll.start();
  }

  function raf2(cb) {
    requestAnimationFrame(() => requestAnimationFrame(cb));
  }

  function waitForLoad(cb) {
    if (document.readyState === "complete") return cb();
    window.addEventListener("load", cb, { once: true });
  }

  function waitForFonts(cb) {
    const fonts = document.fonts;
    if (!fonts || !fonts.ready || typeof fonts.ready.then !== "function")
      return cb();
    fonts.ready.then(cb).catch(cb);
  }

  function scrollToHash(hash) {
    const id = (hash || "").replace("#", "");
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    const y =
      target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo(0, Math.max(0, y));
  }

  function handleInitialHashScroll() {
    if (!location.hash) return;

    const hash = location.hash;

    // ① 先に hash を消してブラウザの自動スクロールを抑止
    history.replaceState(null, "", location.pathname + location.search);

    // ② smooth 停止
    stopSmoothScroll();

    // ③ load → fonts → 2raf の順で待つ
    waitForLoad(() => {
      waitForFonts(() => {
        raf2(() => {
          // ④ 位置を確定してスクロール
          scrollToHash(hash);

          // ⑤ hash を戻す（共有・戻る対策）
          history.replaceState(
            null,
            "",
            location.pathname + location.search + hash,
          );

          // ⑥ smooth 復帰
          startSmoothScroll();
        });
      });
    });
  }

  handleInitialHashScroll();
})();
